export const CONSUMIDOR_FINAL_ID = 4
export const CONSUMIDOR_FINAL_NAME = 'CONSUMIDORFINAL'
export const MONOTRIBUTISTA = 'MONOTRIBUTISTA'
export const RESPONSABLE_MONOTRIBUTISTA = 'RESPONSABLEMONOTRIBUTO'
export const RESPONSABLE_INSCRIPTO = 'RESPONSABLEINSCRIPTO'
export const EMPRESA = 'EMPRESA'
